export default __webpack_public_path__ + "41472842c27a96af0ad1e8983aa1613c.svg";